module.exports = __webpack_public_path__ + "static/media/lily-carter-win.c6904bda.jpg";